/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

document.addEventListener("DOMContentLoaded", function(event) {
  var flktySlider = document.querySelector('.store-benefits.medium-up--hide .wrap');
  var flkty = new Flickity( flktySlider, {
    autoPlay: 3000,
    wrapAround: true,
    cellAlign: 'left',
    pageDots: false,
    prevNextButtons: false
  });

  // if(document.getElementById("custom-text-thread-color")){
  //   document.getElementById('custom-text-thread-color').addEventListener('change', function() {
  //     if(this.value != '') {
  //       document.querySelector('.product-dynamic-buttons').classList.remove('disabled');
  //     } else {
  //       document.querySelector('.product-dynamic-buttons').classList.add('disabled');
  //     }
  //   });
  // }

});

$(".cart-drawer-close-btn").click(function(){
    $(".js-close-header-cart").click(); 
    return false;
});


document.addEventListener('click', function(event) {
    if (event.target.classList.contains('add-to-cart') || 
        event.target.closest('.add-to-cart')) {
        
        const requiredElement = document.querySelector('.required-fake-element');
        const requiredElementText = document.getElementById("requiredText");
        
        if (requiredElement) {
            // Check if element is empty
            const isEmpty = !requiredElement.textContent.trim();
            
            if (isEmpty) {
                requiredElement.style.borderColor = 'red';
                requiredElementText.style.display = "block";
            } else {
                requiredElement.style.borderColor = '';
                requiredElementText.style.display = "none";
            }
        }
    }
});
